import { API_URL, SOCKET_URL } from "@/constants/environment";
import axios from 'axios';
import io from 'socket.io-client';

class ChatService {
    constructor() {
        this.apiUrl = API_URL;
        this.axiosInstance = axios.create({
            baseURL: this.apiUrl,
        });

        // Add a request interceptor to include the auth token
        this.axiosInstance.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("access_token");
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        this.socket = null;
    }

    connect() {
        const token = localStorage.getItem("access_token");
        this.socket = io(SOCKET_URL, {
            transports: ["websocket", "polling"],
            auth: { token } // This sends token via an initial handshake event
        });
    
        this.socket.on('connect', () => {
            console.log('Connected to chat server');
        });
    
        // this.socket.on('message', (message) => {
        //     console.log('Message received:', message);
        // });
    
        this.socket.on('disconnect', () => {
            console.log('Disconnected from chat server');
        });
    
        this.socket.on('connect_error', (error) => {
            console.error('Socket connection error:', error);
        });
    }

    sendMessage(message) {
        if (this.socket) {
            this.socket.emit('message', message);
        } else {
            console.error('Socket not connected');
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    async fetchChatHistory(userId, userType, page = 1, limit = 100) {
        try {
            const response = await this.axiosInstance.get(`/chat/${userId}`, {
                params: { userType, page, limit },
            });
            return response.data.data;
        } catch (error) {
            console.error('Failed to fetch chat history:', error);
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    // async getConversations(conversationId) {
    //     try {
    //         const response = await this.axiosInstance.get(`/chat/history/${conversationId}`);
    //         return response.data.data;
    //     } catch (error) {
    //         console.error('Failed to fetch conversations:', error);
    //         throw new Error(error.response?.data?.message || error.message);
    //     }
    // }

    async getConversations(conversationId, role, page = 1, limit = 200) {
        try {
            // Append page and limit to the query string
            const response = await this.axiosInstance.get(`/chat/history/${conversationId}`, {
                params: {
                    role: role,
                    page: page,  // Default page 1 if not provided
                    limit: limit // Default limit 10 if not provided
                }
            });
            return response.data.data;
        } catch (error) {
            console.error('Failed to fetch conversations:', error);
            throw new Error(error.response?.data?.message || error.message);
        }
    }
    

    async checkConversation(receiverId,role) {
        try {
            const response = await this.axiosInstance.get(`/chat/getConversation`, {
                params: { receiverId, role  },
            });
            return response.data.data.data;
        } catch (error) {
            console.error('Failed to fetch conversation id:', error);
            throw new Error(error.response?.data?.message || error.message);
        }
    }


    async uploadFile(formData) {
        try {

            const response = await this.axiosInstance.post(`/chat/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('Failed to upload file:', error);
            throw new Error(error.response?.data?.message || error.message);
        }
    }


    async checkTwoFactorStatus(role) {
        try {
            const endpoint = role === 'customer' ? '/customers/2fa/status' : '/vendors/2fa/status';
            const response = await this.axiosInstance.get(endpoint);
            return response.data.data;
        } catch (error) {
            console.error('Failed to check 2FA status:', error);
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    async verifyFileAccess(verificationCode, s3Path, role) {
        try {
            const response = await this.axiosInstance.post('/chat/verify-file-access', {
                verification_code: verificationCode,
                s3_path: s3Path
            });
            return response.data.data;
        } catch (error) {
            console.error('Failed to verify file access:', error);
            throw new Error(error.response?.data?.message || error.message);
        }
    }
}

export default new ChatService();